import { Link } from 'react-router';
import { useLatestPhotos, type PhotoFilters } from '../lib/photos';
import { PhotoGrid } from './Photos';
import { EmptyState, Panel } from './ui';

/** The latest photos of a character or a week (M12), with a link to all of them. */
export function PhotosPanel({
  filters,
  limit,
  empty,
  level = 'main',
}: {
  filters: PhotoFilters;
  limit: number;
  /** What to say when there are none. */
  empty: string;
  level?: 'main' | 'side';
}) {
  const q = useLatestPhotos(filters, limit);
  const total = q.data?.total;
  const all = new URLSearchParams({ view: 'photos' });
  if (filters.characterIds.length) all.set('character', filters.characterIds.join(','));
  if (filters.week) all.set('week', filters.week);
  return (
    <Panel title="Photos" level={level} meta={total ? String(total) : undefined}>
      {!q.data ? (
        <EmptyState>{q.isError ? 'Couldn’t load the photos.' : 'Loading…'}</EmptyState>
      ) : q.data.photos.length === 0 ? (
        <EmptyState>{empty}</EmptyState>
      ) : (
        <>
          <PhotoGrid photos={q.data.photos} label="Photos" narrow={level === 'side'} />
          {total !== undefined && total > q.data.photos.length && (
            <p className="m-0 border-t border-line px-4 py-3 text-compact">
              <Link to={`/chronicle?${all.toString()}`}>All {total} photos</Link>
            </p>
          )}
        </>
      )}
    </Panel>
  );
}
